module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/check-circle-61906fd8f51605024051a365d2c51b02.svg";